/* jshint esversion: 6 */

import Highway from '@dogstudio/highway';
import GtmService from '../gtm/gtm.service';

let first = true,
	destroyFirst = true,
	$newScope;

export default class CustomRenderer extends Highway.Renderer {

	// Definisci la funzione isValidJson all'interno della classe
	isValidJson(str) {
		try {
			JSON.parse(str);
		} catch (e) {
			return false;
		}
		return true;
	}

	update() {
		document.title = this.properties.page.title;
		const page = this.properties.page;
		this.updateCanonical(page);

		const body = page.querySelector('body');
		document.querySelector('body').setAttribute('class', body.getAttribute('class'));
	}

	updateCanonical(page) {
		const head = document.querySelector('head');
		Array.from(head.querySelectorAll('[rel="canonical"], [rel="alternate"]')).forEach(node => node.parentNode.removeChild(node));
		const pageHead = page.querySelector('head');
		Array.from(pageHead.querySelectorAll('[rel="canonical"], [rel="alternate"]')).forEach(node => {
			head.appendChild(node);
			if (node.hasAttribute('hreflang')) {
				const target = document.querySelector(`[hreflang-target="${node.getAttribute('hreflang')}"]`);
				if (target) {
					target.href = node.href;
				}
			}
		});
	}

	onEnter() {
		if (!first) {
			const $timeout = CustomRenderer.$timeout;
			$timeout(() => {
				const $compile = CustomRenderer.$compile;
				const view = Array.prototype.slice.call(document.querySelectorAll('.view')).pop();

				// Usa la funzione isValidJson definita all'interno della classe
				const gtmSetupData = view.dataset.gtmSetup;
				if (this.isValidJson(gtmSetupData)) {
					GtmService.pageSetup(JSON.parse(gtmSetupData));
				} else {
					console.error("Invalid JSON data in view.dataset.gtmSetup:", gtmSetupData);
				}

				const element = angular.element(view.childNodes);
				CustomRenderer.scope.root.menuOpened = false;
				CustomRenderer.scope.root.menuProductOpened = false;
				if ($newScope) {
					$newScope.$destroy();
				}
				$newScope = CustomRenderer.scope.$new();
				const content = $compile(element)($newScope);
				CustomRenderer.$newScope = $newScope;
				CustomRenderer.content = content;

				GtmService.pageView();

				$newScope.$on('$destroy', (event) => {
					console.log('.view -> $destroy', event);
				});
			});
		}
	}

	onLeave() {
		if (first) {
			first = false;
			const view = Array.prototype.slice.call(document.querySelectorAll('.view')).shift();
			const element = angular.element(view.childNodes);
			element.on('$destroy', (event) => {
				console.log('.view -> $destroy', event);
			});
		}
	}

	onEnterCompleted() {
		// Metodo vuoto, puoi aggiungere logica se necessario
	}

	onLeaveCompleted() {
		// Metodo vuoto, puoi aggiungere logica se necessario
	}

	static $destroy(from) {
		if (CustomRenderer.scope && CustomRenderer.scope.$root && CustomRenderer.scope.$root.first) {
			CustomRenderer.$timeout(() => {
				CustomRenderer.scope.$root.first = null;
			});
		} else {
			if (this.content && this.content.parentNode) {
				this.content.parentNode.removeChild(this.content);
				this.content = null;
			}
			if (this.$newScope) {
				this.$newScope.$destroy();
				this.$newScope = null;
			}
			if (from.parentNode) {
				from.parentNode.removeChild(from);
			}
		}
	}

	static collectScopes(scope, scopes) {
		scopes = scopes || [];
		if (scope) {
			let child = scope && scope.$$childHead;
			while (child) {
				scopes.push(child);
				scopes = this.collectScopes(child, scopes);
				child = child.$$nextSibling;
			}
		}
		return scopes;
	}
}
